import { appHelper } from '@/main';
import SideActionBase from '@/plugin/sideActions/sideActionBase';
import { Component } from 'vue-property-decorator';

@Component
export default class ImportLedgersActionComponent extends SideActionBase<any> {
    public isLoading: boolean = true;

    public async created() {
        this.isLoading = false;
    }

    public get componentName() {
        return `${appHelper.isCrm() ? 'crm' : 'purchases'}-import-ledgers`;
    }

    public importDone(e): void {
        this.finished(e);
    }
}
